var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    transform: "translate(0.5)",
    fill: "white",
    fillOpacity: 0.01
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.1667 32C59.1667 46.7276 47.2276 58.6667 32.5 58.6667C17.7724 58.6667 5.83337 46.7276 5.83337 32C5.83337 17.2724 17.7724 5.33337 32.5 5.33337C47.2276 5.33337 59.1667 17.2724 59.1667 32ZM25.5198 29.5172C25.8451 29.6569 26.1394 29.8601 26.3854 30.1148L29.8334 33.5628L38.6147 24.7814C38.8607 24.5267 39.1549 24.3236 39.4803 24.1838C39.8056 24.0441 40.1556 23.9705 40.5096 23.9674C40.8637 23.9643 41.2149 24.0318 41.5426 24.1659C41.8703 24.3 42.168 24.498 42.4184 24.7484C42.6688 24.9988 42.8668 25.2965 43.0009 25.6242C43.135 25.9519 43.2024 26.3031 43.1994 26.6572C43.1963 27.0112 43.1227 27.3612 42.983 27.6865C42.8432 28.0119 42.6401 28.3061 42.3854 28.5521L31.7187 39.2188C31.2186 39.7187 30.5405 39.9995 29.8334 39.9995C29.1263 39.9995 28.4481 39.7187 27.948 39.2188L22.6147 33.8854C22.36 33.6394 22.1569 33.3452 22.0171 33.0198C21.8773 32.6945 21.8038 32.3446 21.8007 31.9905C21.7976 31.6364 21.8651 31.2853 21.9992 30.9576C22.1333 30.6298 22.3313 30.3321 22.5816 30.0817C22.832 29.8313 23.1298 29.6333 23.4575 29.4992C23.7852 29.3652 24.1364 29.2977 24.4904 29.3008C24.8445 29.3038 25.1944 29.3774 25.5198 29.5172Z",
    fill: "#47820A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/Success.3dfc50f718dccc5f187cb20bf17a91ed.svg";
export { ForwardRef as ReactComponent };